import FieldWrapper from '../fieldWrapper';
import CleanDateInput from '../../cleanDateInput';

export const ReduxFormCleanDateInput = FieldWrapper(CleanDateInput);
